import { CustomerInterface } from 'client/Interfaces/CustomerInterface'
import _ from 'lodash'
import * as React from 'react'
import AutoComplete from 'react-autocomplete'

import { GlobalEvents } from '../../../Other/GlobalEvents'
import { TestableInterface } from '../interfaces/TestableInterface'
import './CustomAutoComplete.scss'

export interface AutoCompleteStateInterface {
  value: string
  inputProps: object
  isShownClick: boolean
  open: boolean
}

export interface AutoCompleteMaxAllowedInterface {
  limit: number
  breaker: JSX.Element
}

export interface AutoCompleteProps extends TestableInterface {
  onSelect: (event: any, value: any) => void
  onChange: (event: any, value: any) => void
  preserveOrder?: boolean
  inputProps: object
  isReadOnly: boolean
  addNewLabel?: string
  onAddNew?: () => void
  renderItem?: (item, isHighlighted) => any
  data: any[]
  value: string
  maxAllowed?: AutoCompleteMaxAllowedInterface
  open?: boolean // if open === true, show the dropdown list opened
  autoFocus?: boolean
}

export class CustomAutoComplete extends React.Component<AutoCompleteProps, AutoCompleteStateInterface> {
  private addNewId

  private input = null

  private inputProps = { className: 'Controlled Input Text', id: 'products-autocomplete' }

  constructor(props: AutoCompleteProps) {
    super(props)

    this.addNewId = '**Add New**'

    this.state = {
      value: props.value,
      inputProps: this.initializeInputProps(props),
      isShownClick: true,
      open: props.open,
    }

    this.onDivClick = this.onDivClick.bind(this)
    this.matchItemToTerm = this.matchItemToTerm.bind(this)
  }

  private initializeInputProps(props: any) {
    if (props.isReadOnly) {
      return _.merge({}, this.inputProps, props.inputProps, { disabled: true })
    }
    return _.merge({}, this.inputProps, props.inputProps)
  }

  private e
  private time

  public componentDidMount() {
    this.e = GlobalEvents.Click((e) => {
      this.onBlur()
    })
    this.time = new Date().getTime()
    if (
      this.props.autoFocus &&
      this.input &&
      // not necessary for this to work but tests complain that input.focus is not a function.
      typeof this.input.focus === 'function'
    ) {
      this.input.focus()
    }
  }

  public componentWillUnmount() {
    GlobalEvents.unBind(this.e)
  }

  public UNSAFE_componentWillReceiveProps(newProps: any) {
    const { value, inputProps } = this.props
    if (newProps.value !== value && this.state.value !== newProps.value) {
      this.setState({ value: newProps.value })
    }
    if (newProps.inputProps !== inputProps && !_.isEqual(newProps.inputProps, this.state.inputProps)) {
      this.setState({ inputProps: _.merge({}, this.state.inputProps, newProps.inputProps) })
    }
    if (newProps.open && this.state.open !== newProps.open) {
      this.setState({ open: newProps.open })
    }
  }

  private makeDataForItems(data): any {
    if (this.props.preserveOrder) {
      return this.addCustomButton(data)
    }
    let responseData = []
    if (_.size(data) > 0 && data.slice) {
      responseData = this.sortByLabel(data.slice())
    }
    responseData = this.addCustomButton(responseData)
    return responseData
  }

  private sortByLabel(data) {
    return data.sort((a, b) => {
      const textA = a.name.toUpperCase()
      const textB = b.name.toUpperCase()
      // eslint-disable-next-line no-nested-ternary
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
  }

  private addCustomButton(data) {
    _.remove(data, (d) => d.id === this.addNewId)
    if (this.props.addNewLabel) {
      data.push({ name: this.props.addNewLabel, id: this.addNewId })
    }
    return data
  }

  private renderItems(items) {
    return items
      .filter((item) => item && item.key !== this.addNewId)
      .map((item, index) => {
        const internals = []
        if (this.props.maxAllowed) {
          if (this.props.maxAllowed.limit === index) {
            const breaker = this.props.maxAllowed.breaker
            internals.push(breaker)
          }
        }

        internals.push(item)
        return internals
      })
  }

  private getActionButton(items) {
    const actionButton = items.find((item) => item && item.key === this.addNewId)
    if (actionButton) {
      return (
        <span key={actionButton.key} className="action-btn">
          {actionButton}
        </span>
      )
    } else {
      return null
    }
  }

  private matchItemToTerm(item, value) {
    if (this.state.isShownClick || item.id === this.addNewId) {
      return true
    }
    return item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
  }

  private onDivClick() {
    GlobalEvents.prevent(this.e)
    if (this.props.isReadOnly) {
      return
    }
    this.input.focus()
    this.setState({ open: !this.state.open })
  }

  private onBlur() {
    const now = new Date().getTime()
    if (!this.props.open || now > this.time + 100) {
      // this is to prevent onBlur events from customer selector from closing the list
      this.setState({ open: false })
    }
  }

  private onChange(event, value) {
    if (this.props.isReadOnly) {
      return
    }
    this.setState({ isShownClick: value === '', value })
    this.props.onChange(event, value)
  }

  public render() {
    const { props, state } = this
    return (
      <div onClick={this.onDivClick} className={`autoComplete Controlled Input ${props.isReadOnly ? 'readOnly' : ''}`}>
        <span className="jewel"></span>
        <AutoComplete
          open={this.state.open}
          value={this.props.value}
          inputProps={state.inputProps}
          items={this.makeDataForItems(props.data)}
          getItemValue={(item) => item.name}
          ref={(el) => (this.input = el)}
          onChange={this.onChange.bind(this)}
          shouldItemRender={this.matchItemToTerm}
          autoHighlight={true}
          onSelect={(value, item: CustomerInterface) => {
            this.setState({ isShownClick: true, open: false })
            if (this.props.isReadOnly) {
              return
            }
            if (item.id === this.addNewId) {
              if (props.onAddNew) {
                props.onAddNew?.()
              }
            } else {
              this.setState({ value })
              props.onSelect(value, item)
            }
          }}
          renderItem={(item: CustomerInterface, isHighlighted) => {
            if (this.props.renderItem) {
              return this.props.renderItem(item, isHighlighted)
            }
            const classes = []
            if (isHighlighted) {
              classes.push('highLightedItem')
            }
            return (
              <div className={classes.join(' ')} key={item.id}>
                {item.name}
              </div>
            )
          }}
          renderMenu={(items, value, style) => (
            <div className="menu-container">
              <div className="menu-items">{this.renderItems(items)}</div>
              {this.getActionButton(items)}
            </div>
          )}
        />
      </div>
    )
  }
}
